import { GetFormularyListApiParameter } from "@GeriMed/Services/FormularyListService";
import ApplicationStateGeriMed from "@GeriMed/Store/GeriMedState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { createContext } from "react";

export function getFormularyListDataView(state: ApplicationStateGeriMed, parameter: GetFormularyListApiParameter) {
    const data = getDataView(state.dataFormularyList,parameter);
    return data;
}

export const FormularyListDataViewContext = createContext<ReturnType<typeof getFormularyListDataView>>({
    value: undefined,
    isLoading: false,
});
